export default __webpack_public_path__ + "static/media/plus-w.b097b7f3.svg";